import { Component, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavigationMenuItem } from '@models/navigation-menu-item';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { Subscription, tap } from 'rxjs';
import { HeaderService } from '../../header-service';

@Component({
  selector: 'zbp-subnavigation',
  templateUrl: './subnavigation.component.html',
  styleUrls: ['./subnavigation.component.scss'],
  imports: [RouterModule, NgbModule]
})
export class SubnavigationComponent implements OnDestroy, OnInit {
  primaryMenuItems: NavigationMenuItem[] = this.headerService.currentMenus ?? [];

  showSubnav: boolean = false;
  private subscriptions: Subscription[] = [];

  menuSignal: WritableSignal<NavigationMenuItem[]> = signal([]);

  constructor(
    private headerService: HeaderService,
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.headerService.subNavMenuItems$.pipe(
        tap((res) => {
          this.menuSignal.set(res);
        })
      ).subscribe(),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
